export default __webpack_public_path__ + "static/media/cat-3.49cf8e92.svg";